import React from 'react'
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import { Box, Button, Grid } from '@mui/material';


const MappingTabing = ({value,handleConfigFileContent}) => {

  const isProjectOpen = localStorage.getItem('ProjectEditing')

  return (
    <>
      <Grid container direction="row" justifyContent="space-between" sx={{pb: { xs: 2 }}}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider',mb:3 }}>
            <Button className={`tabingButton ${value === 'param' ? 'Mui-selected' : ''}`} component={Link} to="/mapping/parameters">Parameters</Button>
            <Button className={`tabingButton ${value === 'connection' ? 'Mui-selected' : ''}`} component={Link} to="/mapping/connections">Connections</Button>
            <Button className={`tabingButton ${value === 'event' ? 'Mui-selected' : ''}`} component={Link} to="/mapping/events">Events</Button>
            <Button className={`tabingButton ${value === 'modbus' ? 'Mui-selected' : ''}`} component={Link} to="/mapping/modbus">Modbus</Button>
            <Button className={`tabingButton ${value === 'can' ? 'Mui-selected' : ''}`} component={Link} to="/mapping/can/constant-messages">CAN</Button>
            <Button className={`tabingButton ${value === 'homepage' ? 'Mui-selected' : ''}`} component={Link} to="/mapping/homepage">ST Homepage</Button>
        </Box>
        {isProjectOpen &&
          <Box>
              <Button onClick={handleConfigFileContent} color='primary' variant='contained' size='small'> Save File </Button>
          </Box>
        }
      </Grid>
    </>
  )
}

export default MappingTabing